import React, { FC, ReactElement, useState } from "react";
import { Button, ButtonStyle, Textarea } from "@shared/components";
import classnames from "classnames";
import "./index.scss";

interface ModalConfirmProps {
  heading?: string;
  content?: ReactElement | string;
  secondContent?: ReactElement | string;
  onClose: () => void;
  onSuccess: (comment?: string) => void;
  cancelBtnText?: string;
  successBtnText?: string;
  successBtnStyle?: ButtonStyle;
  cancelBtnStyle?: ButtonStyle;
  data?: {
    withComment?: boolean;
  };
}

const ModalConfirm: FC<ModalConfirmProps> = ({
  heading,
  content,
  secondContent,
  onClose,
  onSuccess,
  cancelBtnText,
  successBtnText,
  successBtnStyle,
  cancelBtnStyle,
  data,
}) => {
  const [comment, setComment] = useState("");

  const isDelete = successBtnText?.toLowerCase() === "delete";

  return (
    <div
      className={classnames("modal-content-wrapper", {
        delete: isDelete,
      })}
    >
      <div className="modal-heading">{heading}</div>
      <div className="modal-content">
        {content}
        {secondContent && (
          <>
            <br />
            {secondContent}
          </>
        )}

        {data?.withComment && (
          <Textarea
            rows={5}
            maxLength={300}
            placeholder="Your comment (Optional)"
            value={comment}
            onChange={(v) => setComment(v.currentTarget.value)}
          />
        )}
      </div>
      <div className="modal-actions">
        <div className="modal-actions-btn-block">
          <Button buttonStyle={isDelete ? "blue-bordered" : cancelBtnStyle || "clear"} onClick={onClose}>
            {cancelBtnText}
          </Button>
          <Button type="submit" buttonStyle={successBtnStyle || "clear"} onClick={() => onSuccess(comment?.trim())}>
            {successBtnText}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ModalConfirm;
